<template>
  <div class="zyys-full">
    <div class="zyys-content">
      <div class="zyys-content-inner">
        <div class="zyys-title">{{ title }}</div>
        <div class="zyys-article" v-html="articleContent"></div>
        <div class="zyys-btn">
          <div
            class="zyys-btn-item"
            role="button"
            :style="{ backgroundImage: `url(${btnSprite})` }"
            @click="enter"
          >{{ btnText }}</div>
        </div>
      </div>
    </div>
    <div class="zyys-footer">
      <div class="zyys-city">
        <p class="one">
          技术支持：福建铸远教育科技有限公司
          <a href="https://beian.miit.gov.cn" target="_blank">备案号：闽ICP备14031391号-1</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import btnSprite from '@/assets/icons/zyys-btn-sprite.png'

/** 正文段落内联样式（与目标页逐字一致） */
const P_STYLE = 'margin-bottom: 7.5pt; text-indent: 21pt; line-height: 22.95pt; background: #ffffff;'

/**
 * 欢迎页正文（复刻中国人事考试网"执业药师职业资格考试模拟作答系统"欢迎页 sign/selectArticle classify=1 的返回内容）
 * 保留原始内联样式，保证与目标页渲染结果一致
 */
const ARTICLE_CONTENT = `
<p style="${P_STYLE}">&nbsp;</p>
<p style="${P_STYLE}">&nbsp;</p>
<p style="${P_STYLE}"><span style="font-size: 18px;"><span style="font-family: 微软雅黑; color: #ff0000;"><span style="font-family: 微软雅黑;">模拟作答系统是</span><span style="font-family: 微软雅黑;">执业药师职业资格考试电子化考试的系统界面、作答过程的仿真系统。应试人员可通过本系统熟悉考试作答界面、考试流程和计算器等工具的使用。本系统中试卷结构、题目数量、试题长度及难度等均不具实际参考意义。界面样式可能与正式考试有所不同。</span></span></span></p>
<p style="${P_STYLE}"><span style="font-size: 18px;"><span style="color: #ff0000; font-family: 微软雅黑; text-indent: 21pt;">本系统支持</span><span style="color: #ff0000; font-family: 微软雅黑; text-indent: 21pt;">Chrome、Safari、Firefox、IE10+、Edge等浏览器访问。本系统使用本地输入法，正式考试中，系统支持的输入法有中文（简体）-微软拼音输入法、中文（简体）-极点五笔输入法、中文（简体）-搜狗拼音输入法。</span></span></p>
<p style="${P_STYLE}">&nbsp;</p>
`

export default {
  name: 'ZyysAcc',
  props: {
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      title: '执业药师职业资格考试模拟作答系统',
      btnText: '模拟作答',
      articleContent: ARTICLE_CONTENT,
      btnSprite
    }
  },
  mounted() {
    // 全局 body 的 overflow-y: scroll 会常驻滚动条轨道，使内容整体偏移、与目标页不一致。
    // 进入时改为 auto：内容不足一屏时无滚动条（与目标页一致），超出时仍可正常滚动。
    this.prevBodyOverflowY = document.body.style.overflowY
    document.body.style.overflowY = 'auto'
  },
  beforeDestroy() {
    document.body.style.overflowY = this.prevBodyOverflowY || ''
  },
  methods: {
    /**
     * 进入考试：新窗口打开后端下发的课程入口地址。
     * 未开放（signUp == 0）或地址为空时不跳转，与现有题库入口保持一致。
     */
    enter() {
      const first = (this.data && this.data.classesUrls && this.data.classesUrls[0]) || {}
      const url = first.url || ''
      if (!url) {
        this.$message.warning('课程入口暂不可用')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (first.signUp == 0) {
        this.$message.warning('该科目暂未开放，请先报名')
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="less">
.zyys-full {
  width: 100%;
  height: 100%;
  background: #fff;
  color: #000;
  font-family: 宋体;
  font-size: 14px;
  line-height: normal;
}

.zyys-content {
  min-height: 100%;
  overflow: hidden;
}

.zyys-content-inner {
  padding-bottom: 140px;
}

.zyys-title {
  position: relative;
  margin-top: 30px;
  color: #1b4b85;
  font-size: 34px;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}

.zyys-article {
  width: 1024px;
  margin: 0 auto;

  /* 目标页 reset 会将 p 的默认外边距归零，正文间距全部来自内联样式 */
  /deep/ p {
    margin: 0;
    padding: 0;
  }
}

.zyys-btn-item {
  position: relative;
  display: block;
  width: 432px;
  height: 64px;
  margin: 30px auto;
  color: #333;
  font-size: 24px;
  line-height: 70px;
  text-align: center;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: 0 0;

  &:hover {
    background-position: 0 100%;
  }
}

.zyys-footer {
  margin-top: -51px;
  padding: 10px 0 0;
  background: #f8f8f8;
  border-top: 2px solid #649ac9;

  .zyys-city {
    width: 1024px;
    margin: 0 auto;
  }

  p {
    margin: 0;
    padding-bottom: 15px;
    color: #4b4b4b;
    font-size: 12px;
    text-align: center;
  }

  a {
    display: inline-block;
    margin: 5px 3px;
    color: #4b4b4b;
    font-size: 12px;
    text-decoration: none;
  }

  /* 目标页 .city p a { margin-right: 20px }，p 内所有链接生效 */
  p a {
    margin-right: 20px;
  }
}
</style>
